export default new Map([
  // dev
  ['https://cus-remotesales-dev.linkioapp.com',
    {
      brandId: '63',
      appid: "ww35a1377cc1167234",
      agentid: "1000153",
      clientid: "761f806bdab55dc031857aedd04fcad2",
      wechatAppid: "wxeb13f5b6316ba610",
      wechatClinetid: '0a0343c86225c1f4758514cc1adc0671',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/dev-cus-api',
      apiUrl: 'https://dev-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d',
    }
  ],
  // qa
  ['https://cus-remotesales-qa.linkioapp.com',
    {
      brandId: '63',
      appid: "ww35a1377cc1167234",
      agentid: "1000156",
      clientid: "b7c9f2b602c9f31d55b978595239d366",
      wechatAppid: "wxeb13f5b6316ba610",
      wechatClinetid: '2b1a1d5c043315571dd8c3fbc2a0e12d',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/qa-cus-api',
      apiUrl: 'https://qa-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d',
    }
  ],
  // preprod
  ['https://prp-remotesales.brioni.cn',
    {
      // CUS 组织ID
      brandId: '63',
      // 企微 corpId
      appid: "ww933609f9566c69e1",
      // 企微应用ID
      agentid: "1000012",
      // CUS clientId（wecom）
      clientid: "ef21d72e5877cf4269caae7aa50ff522",
      // 微信公众号 appid
      wechatAppid: "wxcada6430d27c41a5",
      // CUS clientId（wechat）
      wechatClinetid: 'c6df19cc84267578802ec246fb612f4b',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/preprod-cus-api',
      apiUrl: 'https://preprod-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d',
    }
  ],
  // preprod
  ['https://remote-sales-prp.bottegaveneta.cn',
    {
      // CUS 组织ID
      brandId: '58',
      // 企微 corpId
      appid: "ww6b51d307cb47c197",
      // 企微应用ID
      agentid: "1000063",
      // CUS clientId（wecom）
      clientid: "cf21b8d9a47ee23a29b7bb29b827f99b",
      // 微信公众号 appid
      wechatAppid: "wx94225d6bc2f450e6",
      // CUS clientId（wechat）
      wechatClinetid: '1aec09876d852d01c2d9bd7542b7ba7d',
      // interface url
      authUrl: 'https://qa-galassia-openapi.kering.cn/services/preprod-cus-api',
      apiUrl: 'https://preprod-galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: 'wxf62ebe24f5fb4570',
    }
  ],
  // prod
  ['https://remotesales.brioni.cn',
    {
      brandId: '63',
      appid: "ww933609f9566c69e1",
      agentid: "1000013",
      clientid: "3d3b950fca483a9d245724430c4d0cb3",
      wechatAppid: "wxcada6430d27c41a5",
      wechatClinetid: 'b467df8ef33633fbffd38aa9350577b1',
      // interface url
      authUrl: 'https://galassia-openapi.kering.cn/services/cus-api',
      apiUrl: 'https://galassia-cn-api.kering.cn/cus-api/remote-sales/v1',
      etoDomain: 'https://api-suzhou.woaap.com',
      etoAppid: '8ccc27040bc8bc9e6237cc519d73cd5d',
    }
  ],
])